// Crypto Wallets → Custody → Gas funding (SM-267, split out of the old
// /wallet-ops/orders tab bar). Native-gas top-ups the rail sends to deposit
// addresses so they can move ERC-20 balances — internal treasury automation,
// not a user-initiated flow.
import { createFileRoute } from "@tanstack/react-router";
import {
  GasTable,
  OrderListPage,
  useAssetMap,
} from "@/components/wallet-ops/orders";
import { fetchCryptoGasOrders } from "@/lib/wallet-queries";
import type { CryptoGasOrder } from "@/lib/wallet-types";

export const Route = createFileRoute("/_app/wallet-ops/gas")({
  component: GasPage,
});

function GasPage() {
  const assets = useAssetMap();
  return (
    <OrderListPage<CryptoGasOrder>
      title="Gas funding"
      description="Native-gas top-ups sent to deposit addresses so they can move ERC-20 balances. Hover any value for the raw wire form; click to copy."
      cardTitle="Gas funding orders"
      tab="gas"
      fetcher={fetchCryptoGasOrders}
      renderTable={(items) => <GasTable items={items} assets={assets} />}
    />
  );
}
